import { Button, Group, Box, useMantineTheme, Flex } from "@mantine/core";
import { useForm, yupResolver } from "@mantine/form";
import {
  CreateOrganizationInput,
  useCreateOrganizationMutation,
} from "src/generated/graphql";
import { memo } from "react";
import TextInput from "src/components/TextInput/TextInput";
import Textarea from "src/components/Textarea/Textarea";
import ImageUpload from "src/components/ImageUpload";
import { organizationDetailsFormSchema } from "../OrganizationDetails/Detail/components/BasicForm";

type CreateOrganizationFormProps = {
  handleClose: () => void;
};

export const orgInitialValues = {
  name: "",
  description: "",
  logoImage: "",

  street: "",
  zipCode: "",
  city: "",
  country: "",
  state: "",
};

type IFormProps = CreateOrganizationInput;

const CreateOrganizationForm = ({
  handleClose,
}: CreateOrganizationFormProps) => {
  const theme = useMantineTheme();
  const [createOrg, { loading }] = useCreateOrganizationMutation({
    onCompleted: () => {
      handleClose();
      window.location.reload();
    },
  });

  const form = useForm({
    initialValues: orgInitialValues,
    validate: yupResolver(organizationDetailsFormSchema),
  });

  const createOrganization = async (values: IFormProps) => {
    createOrg({
      variables: {
        data: {
          ...values,
        },
      },
    });
  };

  return (
    <Box sx={{ maxWidth: 360 }} mx="auto">
      <form
        onSubmit={form.onSubmit((values) => {
          createOrganization(values);
        })}
      >
        <ImageUpload
          height="170px"
          maxWidth="100%"
          sx={{ margin: "auto" }}
          onReadSuccess={(b64) => form.setFieldValue("logoImage", b64)}
          src={form.values.logoImage}
          alt="organization Image"
        />

        <TextInput withAsterisk label="Name" {...form.getInputProps("name")} />

        <Textarea label="Description" {...form.getInputProps("description")} />

        <TextInput label="Street" {...form.getInputProps("street")} />

        <TextInput label="Zip" {...form.getInputProps("zipCode")} />

        <TextInput label="City" {...form.getInputProps("city")} />

        <TextInput label="Country" {...form.getInputProps("country")} />

        <TextInput label="State" {...form.getInputProps("state")} />

        <Group position="apart" mt="md" style={{ marginTop: 30 }}>
          <Button
            radius="md"
            variant="outline"
            onClick={handleClose}
            style={{
              flex: 1,
              color: theme.colors.secondaryTextColor[6],
            }}
            sx={{
              backgroundColor: theme.colors.secondary[6],
              "&:hover": {
                background: theme.colors.secondary[5],
              },
            }}
          >
            Cancel
          </Button>
          <Button
            radius="md"
            type="submit"
            disabled={loading}
            style={{
              flex: 1,
            }}
            sx={{
              color: theme.colors.primaryTextColor[6],
              "&:hover": {
                backgroundColor: theme.colors.primary[4],
              },
            }}
            loading={loading}
          >
            Create
          </Button>
        </Group>
      </form>
    </Box>
  );
};

export default memo(CreateOrganizationForm);
